import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { isRecordedRoute, startRouteRecording, stopRouteRecording } from '../services/posthog';
import { isPrerendering } from '../utils/detectPrerender';

// Session replay on RECORDED_ROUTES (services/posthog) only. Mounted once, in
// AnalyticsWrapper (src/App.js): it starts recording when a recorded route is
// entered and stops it when the visitor leaves for any other route. Everywhere
// else the snippet's disable_session_recording: true holds.
export const useSessionRecording = () => {
  const { pathname } = useLocation();
  const recorded = isRecordedRoute(pathname);
  const latestRun = useRef(0);

  useEffect(() => {
    if (!recorded || isPrerendering()) return undefined;
    const run = latestRun.current + 1;
    latestRun.current = run;
    let active = true;
    startRouteRecording().then((started) => {
      // Left the route before the recorder chunk arrived: undo the start --
      // unless the visitor already came back, and a newer run owns recording.
      if (started && !active && latestRun.current === run) stopRouteRecording();
    });
    return () => {
      active = false;
      stopRouteRecording();
    };
  }, [recorded]);
};

export default useSessionRecording;
